export const goingWellTextEntryTemplate = [
    {
        type: 'Text Entry',
        questionLabel: 'Going well',
        options: [],
        isSelected: true,
        question: `All things considered, what is going well`,
    }
]